<template lang="pug">
div.vender_detail_container
  div.title 商家信息
  a-row(:gutter="16")
    a-col(:sm="12")    
      a-form-model-item(label="商家" )
        div.p1 {{ model.vendorDTO && model.vendorDTO.name }}
      
    a-col(:sm="12")    
      a-form-model-item(label="座机" )
        div.p1 {{ model.vendorMobile }}
    a-col(:sm="24")    
      a-form-model-item(label="商家地址" )
        div.p1 {{ model.vendorAddress }}
    a-col(:sm="24")    
      a-form-model-item(label="联系人" )
        div.p1 {{ model.vendorContact }}

    
  div.title 客户信息
  a-row(:gutter="16")
    a-col(:sm="12")    
      a-form-model-item(label="收货人姓名" )
        div.p1 {{ model.customerName }}
    
    a-col(:sm="12")    
      a-form-model-item(label="收货人手机" )
        div.p1 {{ model.customerMobile }}
    
    a-col(:sm="24")    
      a-form-model-item(label="收货人地址" )
        div.p1 {{ model.customerAddress }}
  a-row(:gutter="16") 
    //- （出入库、服务）
    //- a-col(:sm="12")   
    //-   a-form-model-item(label="订单类型" )
    //-     div.p1 
    //-       app-dict-display(:value="model.orderType")
    
    //- a-col(:sm="12")    
    //-   a-form-model-item(label="订单子类型" )
    //-     div.p1 
    //-       app-dict-display(:value="model.orderSubType")
    a-col(:sm="12")    
      a-form-model-item(label="出入库类型" )
        div.p1 
          app-dict-display(:value="model.stockType")
    
    a-col(:sm="12")    
      a-form-model-item(label="出入库子类型" )
        div.p1 
          app-dict-display(:value="model.stockSubType")
    a-col(:sm="12")    
      //- （点位、计件）
      a-form-model-item(label="收费模式" )
        div.p1 
          app-dict-display(:value="model.feeMode")
    
    a-col(:sm="12")    
      a-form-model-item(label="订单金额" )
        div.p1 {{ model.amount }} 元
    a-col(:sm="12")  
      a-form-model-item(label="服务费用" prop="serviceFee" )
        div.p1 {{ model.serviceFee }} 元

    a-col(:sm="24")    
      a-form-model-item(label="提货地址" )
        div.p1 {{ model.pickupAddress }}
    a-col(:sm="24")    
      a-form-model-item(label="预约送货时间" )
        div.p1 {{ model.appointmentTime }}
    a-col(v-if="!user.isVendor" :sm="24")    
      a-form-model-item(label="预约送货状态" )
        div.p1 
          app-dict-display(:value="model.appointmentStatus")
    a-col(:sm="24")                    
      a-form-model-item(label="商家备注信息" )
        div.p1 {{ model.vendorComments }}
  div.title.flex 产品列表
  div 
    ProductDTOSVendors(:value="model.orderItems" :productDTOS="model.orderItems" :target="model" detailMode)
</template>

<script>
import ProductDTOSVendors from '../../Modal/ProductDTOSVendors';
import moment from 'moment';
import { GETTER_USER, GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  components: { ProductDTOSVendors },
  props: {
    target: Object,
  },
  data() {
    return {
      // model: {}
      /**
       * 岗位
       * dispatch 调度员
       * orderReceiver  接单员
       * warehouseManagement  库管
       * finance 财务
       */
      post: null,
    };
  },

  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    model() {
      return this.target;
    },
  },
  created() {
    if (this.project?.postDTOS?.length) {
      this.post = this.project.postDTOS[0].code;
    }
  },
  methods: {
    moment,
  },
};
</script>

<style lang="less" scoped>
.title {
  padding: 2px 12px;
  border-left: 4px solid #1890ff;
  margin: 12px 0 12px -8px;
}
.p1 {
  word-break: break-all;
}
</style>

<style lang="less">
.vender_detail_container {
  .ant-form-item {
    margin-bottom: 0;
  }
}
</style>
